import { gql } from 'graphql-tag'

/**
 * Inbox (V2) — read documents.
 *
 * Every payload is a JSON scalar, like the chat summaries: the shapes move
 * often while the pages settle, and a typed SDL would mean a schema change per
 * tweak. See `services/inbox/` for the exact fields.
 */

/**
 * All five sections of the messages inbox in one round-trip:
 * { missedCalls, cases, companies, contacts, staff, unknown, totals }.
 */
export const MESSAGES_INBOX_QUERY = gql`
  query GetMessagesInbox {
    getMessagesInbox
  }
`

/** { cases, companies, staff, contacts, totals }. */
export const NOTES_INBOX_QUERY = gql`
  query GetNotesInbox($limit: Int) {
    getNotesInbox(limit: $limit)
  }
`

/**
 * Who can be ticked to receive a note on this staff member / contact — the
 * lead agency members of the entity's own agencies, minus me. An EMPTY array is
 * a real answer: a contact belonging to no agency has nobody to notify.
 *
 * Returns `[{ id, name, firstName, role }]`.
 */
export const NOTE_RECIPIENTS_QUERY = gql`
  query GetNoteRecipients($kind: String!, $entityId: ID!) {
    getNoteRecipients(kind: $kind, entityId: $entityId)
  }
`
